<div class="e-offices-layout" *ngIf="offices && selectedOffice" role="region">
    <div class="e-office-details" role="tabpanel">
        <h3>Our Offices</h3>
        <div>
            <p class="e-country-label">{{ selectedOffice.location }}</p>
            <p>{{ selectedOffice.name }}</p>
        </div>
        <div class="e-nowrap">
            <p>T: {{ selectedOffice.phone }}</p>
            <p>F: {{ selectedOffice.fax }}</p>
        </div>
        <div>
            <p [innerHTML]="selectedOffice.address"></p>
        </div>
    </div>
    <div class="e-office-list">
        <ul role="tablist">
            <li [ngClass]="{ 'e-state-selected': selectedOffice.id === office.id }"
                *ngFor="let office of offices, let i = index"
                (click)="selectOffice(office)"
                [attr.aria-selected]="selectedOffice.id === office.id"
                [attr.tabindex]="i === 0 ? 0 : -1"
                (keydown)="keyEvents($event, office)" (focus)="setFocus()"
                role="tab" #listItem
            >
                {{ office.location }}
            </li>
        </ul>
    </div>
</div>
